module.exports = __webpack_public_path__ + "img/C.4b1575b.webp";